import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Menu, MenuItem, IconButton } from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';

const Props = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onOptionClick: PropTypes.func.isRequired,
};

export default function DropdownButton({ options, onOptionClick }) {
  const [anchorElement, setAnchorElement] = useState();

  function handleOptionClick(option) {
    onOptionClick(option);
    setAnchorElement();
  }

  return (
    <>
      <IconButton onClick={(event) => setAnchorElement(event.currentTarget)} aria-label="Show Menu">
        <MoreHoriz />
      </IconButton>

      <Menu anchorEl={anchorElement} open={!!anchorElement} onClose={() => setAnchorElement()}>
        {options.map((option, index) => (
          <MenuItem key={index} onClick={() => handleOptionClick(option)}>
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

DropdownButton.propTypes = Props;
